import React, { useState } from 'react';
import { Box, Button, Container, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { updateUser, updateUserPassword } from '../../services/userservice';
import UserProfileCard from '../../components/UserProfileCard';
import ProfileEditForm from '../../components/ProfileEditForm';
import PasswordChangeForm from '../../components/PasswordChangeForm';
import UserAccessHistoryCard from '../../components/UserAccessHistoryCard';
import FeedbackSnackbar from '../../components/FeedbackSnackbar';
import { useAccessHistory } from '../../hooks/useAccessHistory';

function ProfilePage({ user, onBack, onUpdateProfile }) {
  const [feedback, setFeedback] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const { sessoesUnicas, isLoadingHistory, filtroPeriodo, setFiltroPeriodo } =
    useAccessHistory(user?.id);

  const handleCloseFeedback = (event, reason) => {
    if (reason === 'clickaway') return;
    setFeedback((prev) => ({ ...prev, open: false }));
  };

  const handleSaveProfile = async (updatedInfo) => {
    console.log('handleSaveProfile - updatedInfo:', updatedInfo);
    console.log('handleSaveProfile - user antes:', user);

    if (!updatedInfo.nome.trim()) {
      setFeedback({
        open: true,
        message: 'Nome não pode ficar vazio.',
        severity: 'warning',
      });
      return;
    }

    try {
      const userInfo = {
        id: user.id,
        nome: updatedInfo.nome,
        email: user.email,
        tipo: user.tipo, // Preserva o tipo original do usuário
      };

      if (onUpdateProfile) {
        await onUpdateProfile(userInfo);
      }

      setFeedback({
        open: true,
        message: 'Perfil atualizado com sucesso!',
        severity: 'success',
      });
      console.log('handleSaveProfile - user depois:', user);
    } catch (error) {
      console.error('Erro ao salvar perfil:', error);
      setFeedback({
        open: true,
        message: `Erro ao atualizar perfil: ${error.message}`,
        severity: 'error',
      });
    }
  };

  const handleSavePassword = async ({ newPassword, confirmPassword, resetForm }) => {
    console.log('user:', user);
    console.log('user.id:', user.id);
    console.log('newPassword:', newPassword);
    console.log('typeof newPassword:', typeof newPassword);

    if (!user || !user.id) {
      setFeedback({
        open: true,
        message: 'Não é possível alterar a senha: usuário não identificado.',
        severity: 'error',
      });
      return;
    }

    if (!newPassword || typeof newPassword !== 'string') {
      setFeedback({
        open: true,
        message: 'A nova senha não é válida.',
        severity: 'error',
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setFeedback({
        open: true,
        message: 'As senhas não coincidem.',
        severity: 'error',
      });
      return;
    }
    if (newPassword.length < 6) {
      setFeedback({
        open: true,
        message: 'Senha deve ter pelo menos 6 caracteres.',
        severity: 'warning',
      });
      return;
    }

    try {
      await updateUserPassword(user.id, newPassword);
      setFeedback({
        open: true,
        message: 'Senha alterada com sucesso!',
        severity: 'success',
      });
      // Não chamamos resetForm para manter os campos preenchidos
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      setFeedback({
        open: true,
        message: `Erro ao alterar senha: ${
          error.message.includes('password') || error.message.includes('senha')
            ? 'Verifique a senha e tente novamente.'
            : error.message
        }`,
        severity: 'error',
      });
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: '#3A3A3D',
        color: '#fff',
        maxWidth: 1100,
        mx: 'auto',
        borderRadius: 4,
        boxShadow: 7,
        minHeight: '50vh',
      }}
    >
      <FeedbackSnackbar
        open={feedback.open}
        message={feedback.message}
        severity={feedback.severity}
        onClose={handleCloseFeedback}
      />
      <Container maxWidth="lg">
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          sx={{
            mb: 3,
            borderColor: '#777',
            color: '#e0e0e0',
            '&:hover': {
              borderColor: '#fff',
              bgcolor: 'rgba(255,255,255,0.08)',
            },
          }}
        >
          Voltar
        </Button>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <UserProfileCard user={user} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <ProfileEditForm user={user} onSave={handleSaveProfile} />
          </Grid>
        </Grid>
        <Grid container spacing={4} sx={{ mt: 0, alignItems: 'stretch' }}>
          {/* A ordem foi invertida aqui */}
          <Grid item xs={12} sm={4}>
            <UserAccessHistoryCard
              sessoesUnicas={sessoesUnicas}
              isLoadingHistory={isLoadingHistory}
              filtroPeriodo={filtroPeriodo}
              setFiltroPeriodo={setFiltroPeriodo}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <PasswordChangeForm onSave={handleSavePassword} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProfilePage;
